<template>
  <div class="layout">
    <Aside class="layout_aside" @changeActiveIndex="changeActiveIndex" />
    <div class="layout_main">
      <Tools />
      <Search
        ref="search" :recommendList="recommendList" class="layout_search"
        @search="search" />
      <div class="layout_assort">
        <Drapdown :list="filterList" @select="filterSelect" />
        <Drapdown
          ref="classifyDrapdown" class="layout_level2" :minWidth="100" :list="classifyList"
          @select="classifySelect" />
      </div>
      <div class="layout_mat_list">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import Aside from '@/components/Aside/index.vue'
import Tools from '@/components/Tools/index.vue'
import Search from '@/components/Search/index.vue'
import Drapdown from '@/components/Drapdown/index.vue'

import { report } from '@/report/index.js'

const filterList = [
  { name: '全部', value: 1 },
  { name: '最热', value: 2 },
  { name: '最新', value: 3 },
]

const ClassifyItme = { name: '所有分类', id: 0 }

export default {
  name: 'LayoutMain',

  components: { Aside, Tools, Search, Drapdown },

  data () {
    return {
      filterList: Object.freeze(filterList),
      classifyList: []
    }
  },

  computed: {
    categoryArr () {
      return this.$store.state.operational.categoryArr
    },

    homeParams () {
      return this.$store.state.home.home
    },

    activeIndex () {
      return this.$store.state.activeIndex
    },

    recommendList () {
      return this.asideArr[this.activeIndex]?.recommendList || []
    },

    asideArr () {
      return this.$store.state.home.asideArr
    }
  },

  watch: {
    activeIndex: {
      handler () {
        this.setClassifyList()
      },
      immediate: true
    }
  },

  methods: {
    setClassifyList () {
      const params = this.homeParams
      const arr = this.getCategoryItem([params.cat1, params.cat2, params.cat3])

      // 左侧的分类中，有一级、二级，二级分类都是一级分类下面的，右侧的下拉需要过滤
      const asideIds = this.asideArr.map(item => item.cat2)
      const lastArr = arr.filter(item => !asideIds.includes(item.id))

      this.classifyList = [ClassifyItme, ...lastArr]
    },

    getCategoryItem (idArr) {
      let arr = this.categoryArr

      idArr.forEach(id => {
        arr = (arr.find(item => item.id === id)?.list || arr)
      })

      return arr
    },

    toTop () {
      this.$emit('toTop')
    },

    vuexChangeHomeParames (obj) {
      this.toTop()
      this.$store.dispatch('home/vuexChangeHomeParames', obj)
    },

    search (keyword) {
      this.$store.commit('home/vuexResetHomeRes')
      this.$store.dispatch('home/vuexResetClassify', { keyword })

      this.$refs.classifyDrapdown.reset() // 重置为第一个选项
      this.toTop()
    },

    resetListState () {
      this.toTop()
      this.$store.commit('home/vuexResetHomeRes')
    },

    changeActiveIndex (index) {
      this.resetListState()
      this.$refs.search.clearVal() // 不同分类的素材，相距过大，所以，搜索词基本无用
      this.$store.dispatch('home/vuexChangeActiveIndex', index) // 会清空keyword接口字段
    },

    filterSelect ({ item, index }) {
      report('mainclick', { area: 'sort', pos: index })

      this.resetListState()
      this.vuexChangeHomeParames({ sort: item.value })
    },

    classifySelect ({ item }) {
      report('mainclick', { area: 'classify', pos: '' })

      this.resetListState()

      if (item.id === ClassifyItme.id) { // 选择全部分类
        this.$store.dispatch('home/vuexResetActiveIndex')
        return
      }

      const treecode = item.treecode
      if (!treecode) { return } // 因为不知道是几级分类，所以得把所有分类全部重置

      const obj = {}
      treecode.split('-').forEach((id, idx) => {
        obj[`cat${idx + 1}`] = Number(id)
      })

      // 重置搜索内容
      obj.keyword = ''
      this.$refs.search.clearVal() // 重置为第一个选项

      this.vuexChangeHomeParames(obj)
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  position: relative;
  height: 100%;
  padding-left: 70px;

  .layout_aside { position: absolute; left: 0; }

  .layout_main {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .layout_search { border-bottom: 1px solid $border_color; }

    .layout_assort { height: 55px; background-color: #fff; border-bottom: 1px solid $border_color; }
    .layout_level2 { float: right; margin-right: 10px; }

    .layout_mat_list { position: absolute; top: 158px; right: 0; bottom: 2px; left: 0; font-size: 0; }
  }
}
</style>
